import { Component } from '@angular/core';
import { PageOptimizationBase } from '../base/base.component';

@Component({
  selector: 'app-components-specialist-actioncomponents-page-optimization-review-content',
  templateUrl: './review-content.component.html'
})
export class PageOptimizationReviewContentComponent extends PageOptimizationBase {

  override isStepReadyToReject(): boolean {
    this.noteComponent.isRequired = true;
    return super.isStepReadyToReject();
  }

  onAuditChanged(): void {
    this.noteComponent.isRequired = true;
  }

  onContentChanged(): void {
    this.noteComponent.isRequired = true;
  }

  onNoteChanged(): void {
    this.noteComponent.isRequired = true;
  }
}